<div>
  <div class="content-container base-font">
    <span class="content-span full-width text-center display-block">{{data.message}}</span>
  </div>

  <div fxLayout="row" fxLayoutGap="5%">
      <button fxFlex="50%" color="warn" mat-raised-button id="no-button" [mat-dialog-close]="false" tabIndex="-1">Cancelar</button>
      <button fxFlex="50%" color="primary" mat-raised-button id="yes-button" [mat-dialog-close]="true">Aceptar</button>
  </div>
</div>